<template>
  <div class="the-hallbar" :class="{ 'contain-footer': showGovInfo, 'hall-collapse': isBarCollapse, 'mobile-hallbar': isMobileMode }">
    <template v-if="true">
      <div class="hall-header" v-if="!isMobileMode">
        <i class="toggle-hallbar" :class="isBarCollapse ? 'ri-sort-desc' : 'ri-sort-asc'" @click="toggleBar"></i>
        <span>{{ hallDetail.siteName || (data && data.name ? data.name : '') }}</span>
        <i class="close-hallbar ri-close-line" @click="cancelBar"></i>
      </div>
      <el-collapse-transition>
        <div class="hall-main" v-show="!isBarCollapse" v-loading="loading">
          <div class="hall-body">
            <el-scrollbar class="scrollbar">
              <div class="hall-intro">
                <div class="hall-image" v-if="data && data.image && !isMobileMode">
                  <!-- <el-image style="width: 100%; height: 100%;"
                            fit="cover"
                            v-if="hallDetail.siteType == 'D006'||hallDetail.siteType == 'D007'||hallDetail.siteType == 'D008'||hallDetail.siteType == 'D009'"
                            :src="formatBg1(hallDetail.image) || '-'"
                            :preview-src-list="previewImgList">
                  </el-image> -->
                  <el-image style="width: 100%; height: 100%;"
                            fit="cover"
                            :src="formatBg(hallDetail.image) || '-'"
                            :preview-src-list="previewImgList">
                  </el-image>
                  <div class="image-tip">
                    <span><i class="ri-image-2-fill"></i>{{ data && data.image ? data.image.split(',').length : 0 }}张</span>
                  </div>
                </div>
                <div class="hall-base-info" :class="{height: data && data.name && data.name.length > 12}">
                  <div class="hall-name" v-show="!isMobileMode">{{ hallDetail.siteName || (data && data.name ? data.name : '') }}</div>
                  <div class="hall-rate" v-if="hallDetail.fraction">
                    <el-rate v-model="hallDetail.fraction"
                             disabled
                             show-score
                             text-color="#ff9900"
                             score-template="{value}">
                    </el-rate>
                    <div class="rate-switch" @click="showRatePanel = true">我要评价<i class="ri-arrow-right-s-line"></i></div>
                  </div>
                  <div class="hall-type" v-if="showGovInfo">
                    <span>{{ data && data.regionName ? data.regionName :  hallDetail.regionName }}</span>
                    <span>{{ data && data.type ? data.type : '-' }}</span>
                  </div>
                  <div class="hall-type" v-else>
                    <span>{{ hallDetail && hallDetail.regionName ? hallDetail.regionName : '-' }}</span>
                    <span>{{ hallDetail && hallDetail.siteTypeName ? hallDetail.siteTypeName : '-'}}</span>
                  </div>
                  <div class="hall-flow" v-if="(data && data.fluency) || (hallDetail && hallDetail.fluency)">
                    <hall-fluency v-if="data.fluency != -1" :fluency-level="data && data.fluency ? data.fluency : (hallDetail.fluency || null)"></hall-fluency>
                    <div v-if="hallDetail.isReserve && hallDetail.isReserve  != '0'" class="el-button el-button--primary el-button--mini is-plain" @click="goto(hallDetail)" target="_blank">我要预约</div>
                  </div>
                </div>
                <div class="hall-image-list" v-if="isMobileMode">
                  <van-image v-for="(item, index) in imgList"
                             :key="index"
                             width="120"
                             height="80"
                             fit="cover"
                             @click.native="previewMobile(index)"
                             :src="formatBg(data.image)"/>
                </div>
                <div class="hall-tag-info" v-if="isMobileMode && data && data.tag && data.tag.length">
                  <i class="tag-item"
                     v-for="tagItem in (data && data.tag ? data.tag : [])"
                     :key="tagItem"><i class="ri-checkbox-circle-line"></i>{{ tagItem }}</i>
                </div>
                <div class="hall-more-info">
                  <div class="info-item" v-if="hallDetail.address"><i class="ri-map-pin-2-fill"></i>地址：{{ hallDetail.address }}</div>
                  <div class="info-item" v-if="hallDetail.phone"><i class="ri-phone-fill"></i>电话：<a :href="'tel:' + hallDetail.phone">{{ hallDetail.phone }}</a></div>
                  <div class="info-item" v-if="hallDetail.workTimeRange"><i class="ri-time-fill"></i>工作时间：{{ hallDetail.workTimeRange }}</div>
                  <div class="info-item" v-if="hallDetail.siteCode"><i class="ri-calendar-todo-fill"></i>场所简介：{{ hallDetail.introduction }}</div>
                </div>
                <div class="hall-tab-info" :class="{ 'hide-mode-tab': !itemCode }" v-if="showGovInfo&&hallDetail.hallType!='terminal'">
                  <el-tabs v-model="currentMode" type="card" class="mode-tab" stretch>
                    <!-- <el-tab-pane v-if="windowDetail.length" label="窗口信息" name="window">
                      <div v-for="item in windowDetail"
                          :key="item.winNo"> -->
                        <!-- <div class="item-title">{{ item.winName }}</div> -->
                        <!-- <div class="window-item"
                            v-for="windowItem in item.windowList"
                            :key="windowItem.code"> -->
                        <!-- <div class="window-item">
                          <div class="item-name">
                            <label>窗口名称</label>
                            <span>{{ item.winName }}</span>
                          </div>
                          <div class="item-number">
                            <label>窗口号</label>
                            <span>{{ item.winNo }}</span>
                          </div>
                          <div class="item-queue">
                            <label>当前排队</label>
                            <span>{{ item.waitNum }}</span>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane> -->
                    <!-- <el-tab-pane v-else label="窗口信息" name="window">
                      <div>
                        <div class="window-item">
                          <div class="item-name">
                            <label>暂无窗口信息</label>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane> -->
                    <el-tab-pane label="大厅信息" name="hall">
                      <el-tabs v-model="currentTab" class="hall-tab" stretch>
                        <el-tab-pane label="大厅服务" name="service">
                          <div class="tab-detail">
                            <div class="tab-detail-content">
                              <div class="tab-detail-title">服务说明</div>
                              <div class="tab-detail-content">{{ hallDetail.workTimeRange }}</div>
                              <div class="tab-detail-title">咨询电话</div>
                              <div class="tab-detail-content"><a :href="'tel:' + hallDetail.phone">{{ hallDetail.phone }}</a></div>
                              <div class="tab-detail-title">投诉电话</div>
                              <div class="tab-detail-content" v-if="hallDetail.complaintPhone"><a :href="'tel:' + hallDetail.complaintPhone">{{ hallDetail.complaintPhone }}</a></div>
                              <div class="tab-detail-content" v-else><a :href="'tel:' + '0533-12345'">0533-12345</a></div>
                            </div>
                          </div>
                        </el-tab-pane>
                        <template v-if="showMatters">
                          <el-tab-pane label="大厅事项" name="matters">
                            <template v-if="showDept">
                              <el-input
                                placeholder="请输入搜索关键词搜索部门"
                                prefix-icon="el-icon-search"
                                v-model="searchkeyword"
                                size="small"
                                @input="handleInput"
                                maxlength="50"
                                clearable>
                              </el-input>
                              <div class="list-wrap item-wrap" v-loading="deptLoading">
                                <div class="flex"
                                  v-for="(item, index) in DeptList" :key="index" :name="index"
                                  @click="toProject(item.deptCode)">
                                  <i class="header-icon el-icon-s-help"></i>
                                  <span>{{ item.deptName }}</span>
                                  <i class="footer-icon el-icon-arrow-right"></i></div>
                                <p class="loadMore" :style="`text-align: ${ isMobileMode ? 'right' : 'center' }; margin: 10px auto; cursor: pointer;`" v-if="DeptList.length > 0 && deptShowMore" @click="getDeptList">
                                  <span class="el-button el-button--info is-plain el-button--mini">点击加载更多信息</span>
                                </p>
                                <template v-if="deptShowNoData && DeptList.length == 0">
                                    <el-empty description="搜索结果为空，请换个关键词试试！"></el-empty>
                                </template>
                              </div>
                            </template>
                            <template v-if="showItem">
                              <div class="header-search">
                                <el-button type="primary" @click="toBack()">返回</el-button>
                                <el-input
                                  placeholder="请输入搜索关键词搜索事项"
                                  prefix-icon="el-icon-search"
                                  v-model="itemkeyword"
                                  size="small"
                                  @input="ItemInput"
                                  maxlength="50"
                                  clearable>
                                </el-input>
                              </div>
                              <div class="list-wrap" v-loading="matterLoading">
                                <el-collapse v-model="activeNames" accordion>
                                  <el-collapse-item v-for="(item, index) in PriorProjectList" :key="index" :name="index">
                                      <template slot="title">
                                        <div class="flex">
                                          <i class="header-icon el-icon-s-help"></i>{{ item.name }}</div>
                                      </template>
                                      <div class="btn-wrap">
                                          <template>
                                             <el-button size="mini" type="primary" plain @click="xcbl(item)">现场办理</el-button>
                                            <!-- <el-button size="mini" type="primary" plain @click="$emit('showNav', data)">现场办理</el-button> -->
                                            <!-- <el-button size="mini" type="primary" plain @click="zxyy(item)">在线预约</el-button> -->
                                          </template>
                                      </div>
                                  </el-collapse-item>
                                </el-collapse>
                                <p class="loadMore" :style="`text-align: ${ isMobileMode ? 'right' : 'center' }; margin: 10px auto; cursor: pointer;`" v-if="PriorProjectList.length > 0 && matteShowMore" @click="getProjectList">
                                  <span class="el-button el-button--info is-plain el-button--mini">点击加载更多信息</span>
                                </p>
                                <template v-if="matterShowNoData && PriorProjectList.length == 0">
                                    <el-empty description="搜索结果为空，请换个关键词试试！"></el-empty>
                                </template>
                              </div>
                            </template>
                          </el-tab-pane>
                        </template>
                        <!-- <template v-if="showItem">
                          <el-tab-pane label="大厅事项" name="matters">
                            <el-input
                              placeholder="请输入搜索关键词搜索事项"
                              prefix-icon="el-icon-search"
                              v-model="searchkeyword"
                              size="small"
                              @input="handleInput"
                              maxlength="50"
                              clearable>
                            </el-input>
                            <div class="list-wrap" v-loading="matterLoading">
                              <el-collapse v-model="activeNames" accordion>
                                <el-collapse-item v-for="(item, index) in PriorProjectList" :key="index" :name="index">
                                    <template slot="title">
                                      <div class="flex">
                                        <i class="header-icon el-icon-s-help"></i>{{ item.projectName }}</div>
                                    </template>
                                    <div class="btn-wrap">
                                        <template v-if="item.projectId">
                                          <el-button size="mini" type="primary" plain @click="$emit('showNav', data)">现场办理</el-button>
                                          <el-button size="mini" type="primary" plain @click="zxyy(item)">在线预约</el-button>
                                        </template>
                                    </div>
                                </el-collapse-item>
                              </el-collapse>
                              <p class="loadMore" :style="`text-align: ${ isMobileMode ? 'right' : 'center' }; margin: 10px auto; cursor: pointer;`" v-if="PriorProjectList.length > 0 && matteShowMore" @click="getProjectList">
                                <span class="el-button el-button--info is-plain el-button--mini">点击加载更多信息</span>
                              </p>
                              <template v-if="matterShowNoData && PriorProjectList.length == 0">
                                  <el-empty description="搜索结果为空，请换个关键词试试！"></el-empty>
                              </template>
                            </div>
                          </el-tab-pane>
                        </template> -->
                        <el-tab-pane label="大厅简介" name="intro" >
                          <div class="tab-detail">
                            <div class="tab-detail-title">大厅简介</div>
                            <div class="tab-detail-content" v-html="hallDetail.introduction"></div>
                            <div class="tab-detail-title" v-if="hallDetail.windowCount!=0||hallDetail.selfTerminalCount!=0">基础设备</div>
                            <div class="tab-detail-content count-content" style="display: flex;align-items: center;justify-content: center;">
                              <div class="count-item" v-if="hallDetail.windowCount!=0">
                                <div class="item-num"><em>{{ hallDetail.windowCount }}</em>个</div>
                                <div class="item-name">窗口数量</div>
                              </div>
                              <div class="count-item" v-if="hallDetail.selfTerminalCount!=0">
                                <div class="item-num"><em>{{ hallDetail.selfTerminalCount }}</em>台</div>
                                <div class="item-name">自助终端</div>
                              </div>
                            </div>
                          </div>
                        </el-tab-pane>
                        <el-tab-pane label="附近公交" name="route">
                          <div class="tab-detail">
                            <div class="tab-detail-title" v-if="hallDetail.subwayRoute">地铁</div>
                            <div class="tab-detail-content" v-if="hallDetail.subwayRoute">{{ hallDetail.subwayRoute || '-' }}</div>
                            <div class="tab-detail-title" v-if="hallDetail.busStation">公交站</div>
                            <div class="tab-detail-content" v-if="hallDetail.busStation">{{ hallDetail.busStation || '-' }}</div>
                            <div class="tab-detail-title" v-if="hallDetail.busRoute">公交车</div>
                            <div class="tab-detail-content" v-if="hallDetail.busRoute">{{ hallDetail.busRoute || '-' }}</div>
                          </div>
                        </el-tab-pane>
                        <!-- <el-tab-pane label="排队情况" name="queue">
                          <div class="tab-detail">
                            <div class="tab-detail-content dynamic-content">
                              <div class="dynamic-item">
                                <i class="ri-notification-3-line"></i>
                                <span>今日预约</span>
                                <em>{{ hallDetail.dynamicOrder }}</em>
                              </div>
                              <div class="dynamic-item">
                                <i class="ri-device-line"></i>
                                <span>排队数据</span>
                                <em>{{ hallDetail.dynamicQueue }}</em>
                              </div>
                              <div class="dynamic-item">
                                <i class="ri-survey-line"></i>
                                <span>今日办件</span>
                                <em>{{ hallDetail.dynamicApproval }}</em>
                              </div>
                            </div>
                          </div>
                        </el-tab-pane> -->

                      </el-tabs>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="hall-footer" v-if="showGovInfo || isMobileMode">
            <template v-if="!isMobileMode">
              <!-- <div class="btn-column">
                <el-button type="primary" size="small">办事指南</el-button>
              </div>
              <div class="btn-column">
                <el-button type="primary" size="small">预约</el-button>
              </div> -->
            </template>
            <template v-else-if="showGovInfo">
              <div class="footer-btn" style="display:none;"><i class="ri-compass-3-fill"></i>我要纠错</div>

              <van-cell is-link @click="handleNav" class="map-go ditu" :is-link="false">
                <div class="go-main">
                 <img :src="require('@img/map/go-rect.png')">
                  <div>导航</div>
                </div>
              </van-cell>
              <van-popup v-model="show" position="bottom" style="z-index:9999;" :style="{ height: '22%' }">
                <div class="title item">请选择已经安装的app</div>
                <!-- <a :href="pgUrl" v-if="isiOS" @click="its()" class="pg item">苹果自带地图</a> -->
                <a :href="igaodeUrl" v-if="isiOS" class="gaode item">高德地图</a>
                <a :href="gaodeUrl" v-if="!isiOS" class="gaode item">高德地图</a>
                <a :href="baiduUrl" v-if="!isiOS" @click="ts()" class="baidu item">百度地图</a>
                <a :href="ibaiduUrl" v-if="isiOS" @click="its()" class="ibaidu item">百度地图</a>
              </van-popup>
              <div class="footer-btn" style="display:none;"><i class="ri-alarm-fill"></i>在线预约</div>
            </template>
            <template v-else-if="hallDetail.phone">
              <a :href="'tel:' + hallDetail.phone" class="footer-btn" style="width:50%"><i class="ri-phone-fill"></i>联系电话</a>
              <van-cell is-link @click="handleNav" style="width:50%">
                <div class="footer-btn"><i class="ri-compass-discover-fill"></i>导航</div>
              </van-cell>
              <van-popup v-model="show" position="bottom" style="z-index:9999;" :style="{ height: '22%' }">
                <div class="title item">请选择已经安装的app</div>
                <a :href="gaodeUrl" v-if="!isiOS"  class="gaode item">高德地图</a>
                <!-- <a :href="pgUrl" v-if="isiOS" @click="its()" class="pg item">苹果自带地图</a> -->
                <a :href="igaodeUrl" v-if="isiOS" class="gaode item">高德地图</a>

                <a :href="baiduUrl"  v-if="!isiOS" @click="ts()" class="baidu item">百度地图</a>
                <a :href="ibaiduUrl" v-if="isiOS" @click="its()" class="ibaidu item">百度地图</a>
              </van-popup>
            </template>
            <template v-else>
               <van-cell is-link @click="handleNav" style="width:100%">
                <div class="footer-btn"><i class="ri-compass-discover-fill"></i>导航</div>
              </van-cell>
              <van-popup v-model="show" position="bottom" style="z-index:9999;" :style="{ height: '22%' }">
                <div class="title item">请选择已经安装的app</div>
                <a :href="gaodeUrl" v-if="!isiOS"  class="gaode item">高德地图</a>
                <!-- <a :href="pgUrl" v-if="isiOS" @click="its()" class="pg item">苹果自带地图</a> -->
                <a :href="igaodeUrl" v-if="isiOS" class="gaode item">高德地图</a>

                <a :href="baiduUrl"  v-if="!isiOS" @click="ts()" class="baidu item">百度地图</a>
                <a :href="ibaiduUrl" v-if="isiOS" @click="its()" class="ibaidu item">百度地图</a>
              </van-popup>

            </template>
          </div>
        </div>
      </el-collapse-transition>
      <el-dialog class="rate-panel"
                 :class="{ 'mobile-rate-panel': isMobileMode }"
                 :fullscreen="isMobileMode"
                 :close-on-click-modal="false"
                 modal-append-to-body
                 append-to-body
                 :visible.sync="showRatePanel"
                 width="540px">
        <div slot="title">
          <div class="rate-title" v-if="isMobileMode">我要评价</div>
          <div class="rate-hall-name">{{ data && data.name ? data.name : '' }}</div>
          <div class="rate-hall-type">
            <span>{{ data && data.regionName ? data.regionName : '-'}}</span>
            <span>{{ data && data.type ? data.type : '-' }}</span>
          </div>
        </div>
        <div class="rate-main">
          <div class="rate-item">
            <div class="rate-label"><i class="ri-thumb-up-line"></i>满意度</div>
            <div class="rate-content">
              <el-rate v-model="rateNum"
                       :texts="['非常不满意', '不满意', '基本满意', '满意', '非常满意']"
                       show-text>
              </el-rate>
            </div>
          </div>
          <div class="rate-item">
            <div class="rate-label"><i class="ri-user-smile-line"></i>满意的原因</div>
            <div class="rate-content">
              <el-checkbox-group v-model="rateTag">
                <el-checkbox v-for="item in tagsNames"
                             :key="item"
                             :label="item"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="rate-input">
            <el-input type="textarea"
                      :rows="5"
                      placeholder="留下您的宝贵意见..."
                      v-model="rateInput">
            </el-input>
          </div>
        </div>
        <div slot="footer" style="text-align: center;">
          <el-button @click="resetRateForm" type="info">重置</el-button>
          <el-button type="primary" @click="submitAppraise">匿名提交</el-button>
        </div>
      </el-dialog>
    </template>
    <el-drawer
      :title="appointmentTitle"
      :class="{ 'mobile-drawer-panel': isMobileMode }"
      size="33%"
      append-to-body
      modal-append-to-body
      :visible.sync="showAppointment"
      :direction="'rtl'"
      :before-close="handleAppointmentClose">
      <div class="appoint-header" slot="title">{{appointmentTitle}}</div>
      <div class="appoint-drawer-wrap">
        <div class="item-info">
          <div class="label">{{appointItem.name}}</div>
          <div class="sub-label">{{appointItem.orgName}}</div>
        </div>
        <div class="step-wrap">
          <div class="label"><i class="ri-arrow-right-circle-line"></i>请选择时间</div>
          <el-form ref="form1" :model="appointForm" :rules="appointFormRules" label-width="80px">
            <el-form-item label="" label-width="0" prop="date">
              <el-date-picker
                style="width: 100%"
                v-model="appointForm.date"
                type="date"
                @change="getAppointTimeList"
                :pickerOptions="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="" label-width="0" prop="period">
              <div class="order-period">
                <template v-if="!loadingAppointmentTime && appointmentTimeList.length">
                  <div :class="['period', {active: item === currentPeriod}]" v-for="(item, i) in appointmentTimeList" :key="i" @click="selectPeriod(item, i)">
                    <div class="time">{{item.timeRange}}</div>
                    <div class="time"><span class="hign-light">{{item.leftNum}}</span>个余号</div>
                  </div>
                </template>
                <template v-if="appointForm.date && loadingAppointmentTime">
                  <div class="no-data">正在加载此预约时间信息...</div>
                </template>
                <template v-if="appointForm.date && !loadingAppointmentTime && !appointmentTimeList.length">
                  <div class="no-data">无此预约时间信息</div>
                </template>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="step-wrap">
          <div class="label"><i class="ri-arrow-right-circle-line"></i>请填写信息</div>
          <el-form ref="form2" :model="appointForm" :rules="appointFormRules" label-width="80px">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="appointForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="userCardNo">
              <el-input v-model="appointForm.userCardNo"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="userPhone">
              <el-input v-model="appointForm.userPhone"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-wrap">
          <el-button type="" @click="clearAppointForm">取消</el-button>
          <el-button type="danger" @click="submitAppointment" :loading="appointSubmitLoading">提交</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import Bus from '@/api/bus'
import { Image as VanImage, ImagePreview, Toast, Cell } from 'vant'
import {
  HALL_URLTYPE,
  WECHAT_URL,
  WECHAT_SYS,
  service_url,
  bsznUrl,
  zxyyUrl,
  accessToken
} from '@/api/config'
import {
  getHallInfo,
  getSiteInfo,
  getProjectList,
  getItemList,
  getDeptList,
  submitAppraise,
  getWindowListInfo,
  getPriorProjectListByItemCode,
  getPriorProjectInfo
} from '@/api/hallApi'
import {
  getAppointTimeList,
  submitAppointment
} from '@/api/appointment.api.js'
import { Notification } from 'element-ui'
import { mapGetters } from 'vuex'
import hallMixins from '@/mixins/hallMixins'
import store from '@/store'
import util from '@/mixins/util'
Vue.use(VanImage)
export default {
  name: 'TheHallbar',
  mixins: [hallMixins, util],
  components: {
    HallFluency: () => import('@comp/HallFluency'),
    'van-cell': Cell
  },
  props: {
    // sidebarStatus: {
    //   type: String,
    //   default: ""
    // },
    // 大厅基本数据
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    // 事项标识，可选
    itemCode: {},
    //
    isMobileMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      itemkeyword: '',
      appointmentTitle: '在线预约',
      appointItem: {},
      // showAppointment: false,
      appointForm: {
        userName: '',
        userCardNo: '',
        userPhone: '',
        date: '',
        period: ''
      },
      appointFormRules: {
        userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        userCardNo: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        userPhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        period: [{ required: true, message: '请选择时间段', trigger: 'blur' }]
      },
      appointmentTimeList: [
        // { time: "08:30 - 09:00", num: 6 },
        // { time: "09:00 - 11:00", num: 14 },
        // { time: "11:00 - 13:00", num: 8 },
        // { time: "13:00 - 15:00", num: 6 },
        // { time: "15:00 - 17:00", num: 10 },
        // { time: "17:00 - 17:30", num: 2 },
      ],
      currentPeriod: null,
      loadingAppointmentTime: false,
      pickerOptions: {
        disabledDate (time) {
          var d = time.getDay()
          return !(time.getTime() > Date.now() && d != 6 && d != 0)
        }
      },
      appointSubmitLoading: false,
      show: false,
      imgUrl: process.env.VUE_APP_HALL_IMG_URL,
      // 折叠面板
      isBarCollapse: false,
      // 显示评价面板
      showRatePanel: false,
      // 事项大厅窗口信息
      windowDetail: [
        // {
        //   itemCode: "1",
        //   itemName: "职工非因工伤残或因病丧失劳动能力程度鉴定",
        //   windowList: [
        //     {
        //       // 标识
        //       code: "1",
        //       // 窗口名称
        //       name: "一窗受理",
        //       // 窗口号
        //       number: "1001",
        //       // 当前排队
        //       queue: 6
        //     },
        //     {
        //       code: "2",
        //       name: "一窗受理",
        //       number: "1002",
        //       queue: 4
        //     },
        //     {
        //       code: "3",
        //       name: "一窗受理",
        //       number: "1003",
        //       queue: 6
        //     }
        //   ]
        // }
      ],
      // 大厅详细信息
      hallDetail: {
        hallId: '', // hallId: "709556015762243584",
        hallCode: '', // hallCode: "370100001",
        hallName: '', // hallName: "济南市政务服务中心",
        hallEnglishName: '', // hallEnglishName: "",
        regionCode: '', // regionCode: "370100",
        regionName: '', // regionName: "济南市",
        hallLevel: '', // hallLevel: "2",
        hallType: '', // hallType: "governs",
        hallTypeName: '', // hallTypeName: "行政服务大厅",
        hallMode: '', // hallMode: "zwfwzx",
        hallModeName: '', // hallModeName: "政务服务中心",
        isReserve: '', // isReserve: "1",
        workTimeRange: '', // workTimeRange: "09:00-12:00,13:00-17:00",
        introduction: '', // introduction: "<p>12312412342</p>",
        phone: '', // phone: "0531-68967300",
        complaintPhone: '', // complaintPhone: "0531-68967100",
        longitude: '', // longitude: "116.989407",
        latitude: '', // latitude: "36.6915",
        distance: '', // distance: 12767.1,
        address: '', // address: "山东省济南市天桥区无影山东路29号",
        subwayRoute: '', // subwayRoute: "地铁1号线，凤凰路C出口",
        busRoute: '', // busRoute: "87路；63路；123路",
        fraction: '', // fraction: 5,
        fluency: '', // fluency: 0,
        image: '', // image: "033737cd-1538-11ec-82f8-fa163ed1ebf0.jpg",
        labelNames: [
          // "母婴室",
          // "无线上网",
          // "茶水间",
          // "免费停车",
          // "自动售卖机",
          // "无线充电"
        ],
        windowCount: 32,
        selfTerminalCount: 15,
        approvals: 0,
        scenePictures: {
          frontDoor: {
            name: '正门',
            pictures: []
          },
          internal: {
            name: '内景',
            pictures: []
          },
          appearance: {
            name: '外景',
            pictures: []
          }
        },
        rnote: '<p></p>',
        approval: false,
        appraise: false,
        // 新增字段，大厅简介
        intro: '', // "济南市高新区政务服务大厅，建筑面积约2200平方米，覆盖3个行政村和10个商业小区，3个专业市场",
        // 新增字段，今日预约
        dynamicOrder: 182,
        // 新增字段，排队数据
        dynamicQueue: 34,
        // 新增字段，排今日办件
        dynamicApproval: 421,
        // 新增字段，公交站
        busStation: '', // "舜华路颖秀路站"
        wechatLinks: '',
        webLinks: '',
        appLinks: ''
      },
      // 图集
      imgList: [
        // "hallLogo.97d9945d.png",
        // "hallLogo.97d9945d.png",
        // "hallLogo.97d9945d.png",
        // "hallLogo.97d9945d.png",
        // "hallLogo.97d9945d.png"
      ],
      // 当前模块 window/hall
      currentMode: 'hall',
      // 当前大厅信息tab intro/service/queue/route
      currentTab: 'service',
      // currentTab: "matters",
      // 评价星级
      rateNum: null,
      // 评价标签可选项
      rateTagOption: [
        // "母婴室",
        // "无线上网",
        // "茶水间",
        // "免费停车",
        // "自动售卖机",
        // "休息区",
        // "前台消毒洗手液",
        // "24小时终端",
        // "无线充电"
      ],
      // 已选评价标签
      rateTag: [],
      // 评价内容
      rateInput: '',
      loading: false,
      TimeId: null, // 延时句柄
      searchkeyword: '', // 搜索事项时关键词
      matterLoading: false,
      deptLoading: false,
      activeNames: [],
      PriorProjectList: [],
      DeptList: [],
      matteShowMore: false,
      deptShowNoData: false,
      deptShowMore: false,
      matterShowNoData: false,
      pageNum: 1,
      pageSize: 30,
      deptpageNum: 1,
      deptpageSize: 10,
      submitting: false,
      showItem: false,
      showDept: true,
      deptCode: ''
    }
  },
  computed: {
    showMatters () {
      const show = !this.data || !this.data.fromList
      return show
    },
    pgUrl () {
      this.data = this.data || {}
      let longitude = this.data.longitude
      let latitude = this.data.latitude
      if (this.data.siteType == 'D006') {
        (longitude = this.bMapTransQQMap(longitude, latitude).lng),
        (latitude = this.bMapTransQQMap(longitude, latitude).lat)
      }
      let name = ''
      if (this.data.hallName) {
        name = this.data.hallName
      } else {
        name = this.data.siteName
      }
      return `http://maps.apple.com/maps?saddr=&daddr=${name}`
    },

    igaodeUrl () {
      this.data = this.data || {}
      let longitude = this.data.longitude
      let latitude = this.data.latitude
      if (this.data.siteType == 'D006') {
        (longitude = this.bMapTransQQMap(longitude, latitude).lng),
        (latitude = this.bMapTransQQMap(longitude, latitude).lat)
      }
      let name = ''
      if (this.data.hallName) {
        name = this.data.hallName
      } else {
        name = this.data.siteName
      }
      return (
        'iosamap://path?sourceApplication=applicationName&did=&dlat=' +
        latitude +
        '&dlon=' +
        longitude +
        '&dname=' +
        name +
        '&dev=0&t=0'
      )
      // return `iosamap://navi?sourceApplication=amap&poiname=&poiid=&lat=${latitude}&lon=${longitude}&dev=1&style=2`
    },
    gaodeUrl () {
      this.data = this.data || {}
      let longitude = this.data.longitude
      let latitude = this.data.latitude
      if (this.data.siteType == 'D006') {
        (longitude = this.bMapTransQQMap(longitude, latitude).lng),
        (latitude = this.bMapTransQQMap(longitude, latitude).lat)
      }
      let name = ''
      if (this.data.hallName) {
        name = this.data.hallName
      } else {
        name = this.data.siteName
      }
      return (
        'amapuri://route/plan/?sid=&slat=&slon=&sname=&did=&dlat=' +
        latitude +
        '&dlon=' +
        longitude +
        '&dname=' +
        name +
        '&dev=0&t=0'
      )
    },
    baiduUrl () {
      this.data = this.data || {}
      const longitude = this.data.longitude
      const latitude = this.data.latitude
      let lngs = ''
      let lats = ''
      if (this.data.siteType == 'D006') {
        (lngs = this.data.longitude), (lats = this.data.latitude)
      } else {
        lngs = this.qqMapTransBMap(longitude, latitude).lng
        lats = this.qqMapTransBMap(longitude, latitude).lat
      }
      let name = ''
      if (this.data.hallName) {
        name = this.data.hallName
      } else {
        name = this.data.siteName
      }
      let url = ''
      url =
        'bdapp://map/direction?origin=&destination=name:' +
        name +
        '|latlng:' +
        lats +
        ',' +
        lngs +
        '&mode=driving&src=andr.baidu.openAPIdemo'
      // url="bdapp://map/direction?origin=&destination=" +
      //     name +
      //     "&mode=driving&src=andr.baidu.openAPIdemo";
      // window.open(url, "_blank");
      return url
    },
    ibaiduUrl () {
      this.data = this.data || {}
      const longitude = this.data.longitude
      const latitude = this.data.latitude
      let lngs = ''
      let lats = ''
      if (this.data.siteType == 'D006') {
        (lngs = this.data.longitude), (lats = this.data.latitude)
      } else {
        lngs = this.qqMapTransBMap(longitude, latitude).lng
        lats = this.qqMapTransBMap(longitude, latitude).lat
      }
      let name = ''
      if (this.data.hallName) {
        name = this.data.hallName
      } else {
        name = this.data.siteName
      }
      let url = ''
      url =
        'baidumap://map/direction?origin=&destination=name:' +
        name +
        '|latlng:' +
        lats +
        ',' +
        lngs +
        '&mode=driving&src=ios.baidu.openAPIdemo'
      // url =
      //   "bdapp://map/direction?origin=&destination=name:" +
      //   name +
      //   "|latlng:" +
      //   lats +
      //   "," +
      //   lngs +
      //   "&mode=driving&src=andr.baidu.openAPIdemo";
      // url="bdapp://map/direction?origin=&destination=" +
      //     name +
      //     "&mode=driving&src=andr.baidu.openAPIdemo";
      // window.open(url, "_blank");
      return url
    },
    isiOS () {
      const u = navigator.userAgent
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    },
    ...mapGetters(['tagsNames']),
    // 是否显示tab页及页脚
    showGovInfo () {
      const that = this
      return !(that.data && that.data.siteId)
      return true
      // 此处仅根据供暖网点category判断，具体情况应根据实际开发时调整
      return !(that.data && that.data.category && that.data.category === '2-1')
    },
    previewImgList () {
      const that = this
      const previewArr = []
      const list = that.hallDetail.image.split(',')

      // let previewArr = [];
      // let list = that.hallDetail && that.hallDetail.image ? that.hallDetail.image.split(",") : [];
      _.forEach(list, function (item) {
        previewArr.push(that.formatBg(item))
      })
      return previewArr
    }
  },
  watch: {
    data (newVal) {
      const that = this
      console.log('newVal')
      console.log(newVal)
      if (!newVal || !newVal.code) return
      // 不是通过事项搜索进来的
      if (!newVal.fromList) {
        that.currentTab = 'matters'
      } else {
        // 通过事项搜索进来的
        that.currentTab = 'service'
      }
      that.isBarCollapse = false
      that.pageNum = 1
      that.deptpageNum = 1
      that.PriorProjectList = []
      that.DeptList = []
      that.imgList = that.getImgList(that.data)
      that.itemkeyword = ''
      that.toBack()
      that.getHallInfo()
    },
    itemCode (newValue) {
      const that = this
      if (typeof newValue === 'object') {
        that.getAppointmentItemInfo()
        return
      }
      if (newValue) {
        that.currentMode = 'window'
      } else {
        that.currentMode = 'hall'
      }
    },
    '$store.state.userInfo' (newVal) {
      this.appointForm = Object.assign(this.appointForm, {
        userName: newVal.name ? newVal.name : '',
        userCardNo: newVal.cardNo ? newVal.cardNo : '',
        userPhone: newVal.phone ? newVal.phone : ''
      })
    }
  },
  mounted () {
    console.log(this.isMobile())
  },
  methods: {
    goto (row) {
      let url = ''
      if (this.isMobile()) {
        url = row.appLinks
        url = url.indexOf('?') > -1 ? url + '&hallName=' + this.hallDetail.hallName : url + '?hallId=' + this.hallDetail.hallId + '&hallName=' + this.hallDetail.hallName
        window.location.href = url
      } else {
        url = row.webLinks
        url = url.indexOf('?') > -1 ? url : url + '?hallId=' + this.hallDetail.hallId
        window.open(url)
      }
    },
    getAppointTimeList () {
      if (!this.appointForm.date) return
      this.loadingAppointmentTime = true
      getAppointTimeList({
        // projectId: this.appointItem.projectId,
        projectId: this.appointItem.id,
        rDate: this.appointForm.date
      })
        .then(res => {
          if (res.data && res.data.info && res.data.info.ruleList) {
            this.appointmentTimeList = res.data.info.ruleList
          } else {
            this.appointmentTimeList = []
          }
        })
        .catch(err => {
          this.appointmentTimeList = []
        })
        .finally(() => {
          this.loadingAppointmentTime = false
        })
    },
    selectPeriod (item, i) {
      this.currentPeriod = item
      this.appointForm.period = item.timeRange
    },
    handleAppointmentClose (done) {
      this.clearAppointForm()
      // this.$confirm('确认关闭？')
      // .then(_ => {
      done()
      // })
      // .catch(_ => {});
      // }
    },
    clearAppointForm () {
      this.appointForm = {
        userName: '',
        userCardNo: '',
        userPhone: '',
        date: '',
        period: ''
      }
      this.appointmentTimeList = []
      this.loadingAppointmentTime = false
      this.appointSubmitLoading = false
      this.showAppointment = false
    },
    submitAppointment () {
      this.$refs.form1.validate((valid, params) => {
        if (!this.appointForm.period) {
          params.period = [
            {
              message: '请选择时间段', field: 'period'
            }
          ]
          return false
        }
        this.$refs.form2.validate(vali => {
          if (valid && vali) {
            this.appointSubmitLoading = true
            submitAppointment({
              ruleId: this.currentPeriod.ruleId,
              // projectId: this.appointItem.projectId,
              projectId: this.appointItem.id,
              userName: this.appointForm.userName,
              userPhone: this.appointForm.userPhone,
              userCardNo: this.appointForm.userCardNo,
              cardType: '10',
              dataFrom: '1',
              configParam: {}
            })
              .then(res => {
                this.appointSubmitLoading = false
                Notification.success({ title: '成功', message: '预约成功' })
                setTimeout(() => {
                  this.clearAppointForm()
                  this.showAppointment = false
                }, 1000)
              })
              .catch(err => {
                Notification.error({ title: '失败', message: '预约失败' })
                this.appointSubmitLoading = false
              })
          }
        })
      })
    },
    ts () {
      var loadDateTime = new Date()
      window.setTimeout(function () {
        var timeOutDateTime = new Date()
        if (timeOutDateTime - loadDateTime < 5000) {
          console.log(
            'timeOutDateTime - loadDateTime',
            timeOutDateTime - loadDateTime
          )
          // alert("请先安装app");
          // window.location=url;
        } else {
          window.close()
          // Toast("请先安装百度地图");
        }
      }, 1000)
    },
    its () {
      var loadDateTime = new Date()
      window.setTimeout(function () {
        var timeOutDateTime = new Date()
        if (timeOutDateTime - loadDateTime < 6000) {
          Toast('未检测到百度地图客户端，请安装后重试')
          // 找不到app时执行的操作
        }
      }, 3000)
    },
    qqMapTransBMap (lng, lat) {
      const x_pi = 3.14159265358979324 * 3000.0 / 180.0
      const x = lng
      const y = lat
      const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
      const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
      const lngs = z * Math.cos(theta) + 0.0065
      const lats = z * Math.sin(theta) + 0.006
      return {
        lng: lngs,
        lat: lats
      }
    },
    bMapTransQQMap (lng, lat) {
      const x_pi = 3.14159265358979324 * 3000.0 / 180.0
      const x = lng - 0.0065
      const y = lat - 0.006
      const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
      const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
      const lngs = z * Math.cos(theta)
      const lats = z * Math.sin(theta)

      return {
        lng: lngs,
        lat: lats
      }
    },
    getHallInfo () {
      const that = this
      if (that.loading || !that.data) return

      if (
        that.data.siteType == 'D006' ||
        that.data.siteType == 'D007' ||
        that.data.siteType == 'D008' ||
        that.data.siteType == 'D009'
      ) {
        // return
        that.hallDetail = that.data
      } else {
        that.loading = true
        that.data = that.data || {}
        const params = {
          latitude: that.data.latitude,
          longitude: that.data.longitude
        }
        if (that.data.siteId) {
          // Vue.off("click")
          // return false;
          params.siteId = that.data.siteId
          getSiteInfo(params)
            .then(res => {
              const { state, info, message } = res.data || {}
              if (state == 1) {
                that.hallDetail = info
              } else {
                Notification.error({
                  title: '错误',
                  message: message || '大厅信息获取失败'
                })
              }
              that.loading = false
              that.$emit('stopLoading')
            })
            .catch(err => {
              const { message } = err
              that.loading = false
              that.$emit('stopLoading')
              Notification.error({
                title: '错误',
                message: message || '信息获取失败了'
              })
            })
          return
        }
        params.hallId = that.data.hallId
        if (!params.hallId) return that.loading = false
        getHallInfo(params)
          .then(res => {
            const { state, info, message } = res.data || {}
            if (state == 1) {
              that.hallDetail = info

              if (!this.itemCode || this.itemCode.length == 18)
              // that.getProjectList();
              { that.getDeptList() }
            } else {
              Notification.error({
                title: '错误',
                message: message || '大厅信息获取失败'
              })
            }
            that.loading = false
            that.$emit('stopLoading')
          })
          .catch(err => {
            const { message } = err
            that.loading = false
            that.$emit('stopLoading')
            Notification.error({
              title: '错误',
              message: message || '信息获取失败了'
            })
          })
        // getWindowListInfo({
        //   hallId: this.data.hallId
        // })
        //   .then(res => {
        //     let { state, info, message } = res.data || {};
        //     if (state == 1) {
        //       that.windowDetail = info;
        //       that.getProjectList();
        //     } else {
        //       Notification.error({
        //         title: "错误",
        //         message: message || "大厅窗口信息获取失败"
        //       });
        //     }
        //   })
        //   .catch(err => {
        //     let { message } = err;
        //     Notification.error({
        //       title: "错误",
        //       message: message || "信息获取失败了"
        //     });
        //   });
      }
    },
    resetRateForm () {
      const that = this
      that.rateNum = null
      that.rateTag = []
      that.rateInput = ''
    },
    cancelBar () {
      this.showItem = false
      this.showDept = true
      Bus.$emit('val', true)
      this.$emit('cancel-bar')
    },
    toggleBar () {
      const that = this
      that.isBarCollapse = !that.isBarCollapse
    },
    hideBar () {
      const that = this
      that.isBarCollapse = true
    },
    showBar () {
      const that = this
      that.isBarCollapse = false
    },
    previewMobile (index) {
      const that = this
      ImagePreview({
        images: that.previewImgList,
        startPosition: index
      })
    },
    showPopup () {
      this.show = true
      this.$emit('showNav')
    },
    handleNav () {
      const that = this
      that.$emit('show-nav', that.data)
    },
    getImgList (data) {
      const { image = '' } = data || {}
      const that = this
      const list = image ? image.split(',') : []
      const arr = []
      _.forEach(list, item => {
        arr.push(that.formatBg(item))
      })
      return arr
    },
    formatBg (image) {
      if (!image) return ''
      return this.loadImage(image)
    },
    // 加载图片
    loadImage (image) {
      if (image == undefined || image == '') {
        return this.hallLogo
      }
      let baseURL = ''
      if (this.hallDetail.siteType == 'D006' || this.hallDetail.siteType == 'D007' || this.hallDetail.siteType == 'D008' || this.hallDetail.siteType == 'D009') {
        return image
      }
      if (HALL_URLTYPE == '1') {
        baseURL = WECHAT_URL
        return (
          baseURL +
          'servlet/MobileAccessService?area=317&sys=' +
          WECHAT_SYS +
          '&action=fileDownload&downLoadType=download' +
          '&fileName=' +
          image
        )
      }
      if (HALL_URLTYPE == '2') {
        return '/fwapi/c/api.transfer/file_Map?access_token=' + accessToken + '&fileName=' + image
      }
    },
    getDeptList () {
      const that = this
      that.deptLoading = true
      const params = {}
      params.page = that.deptpageNum
      params.size = that.deptpageSize
      params.hallId = that.data.hallId
      // params.hallId = '1189946829992157184'
      if (that.searchkeyword != undefined && that.searchkeyword != '') {
        params.deptName = that.searchkeyword
      }
      getDeptList(params)
        .then(res => {
          that.deptLoading = false
          const { state, rows, records, total, message } = res.data
          if (state === 1) {
            if (records != undefined && records != 0) {
              if (that.deptpageNum == 1) {
                that.DeptList = rows
              } else {
                that.DeptList.push(...rows)
              }
              if (total == that.deptpageNum) {
                that.deptShowMore = false
              } else {
                that.deptShowMore = true
                that.deptpageNum++
              }
              console.log('deptList', that.DeptList)
              // 是否展示无数据信息
              that.deptShowNoData = false
            } else {
              that.DeptList = rows
              that.deptShowNoData = true
            }
          } else {
            Notification.error({
              title: '错误',
              message: message || '优先办事事项大厅列表获取失败'
            })
          }
        })
    },
    toBack () {
      const that = this
      that.showItem = false
      that.showDept = true
      this.deptpageNum = 1
      this.getDeptList()
    },
    toProject (code) {
      const that = this
      that.showItem = true
      that.showDept = false
      that.deptCode = code
      this.pageNum = 1
      // that.showMatters = false
      that.getProjectList()
    },
    // 0.7秒盘内没有任何输入操作的时候触发（事项搜索）
    handleInput () {
      clearTimeout(this.TimeId)
      this.TimeId = setTimeout(() => {
        this.deptpageNum = 1
        this.getDeptList() // 定时器生效时执行的方法
      }, 700)
    },
    ItemInput () {
      clearTimeout(this.TimeId)
      this.TimeId = setTimeout(() => {
        this.pageNum = 1
        this.getProjectList() // 定时器生效时执行的方法
      }, 700)
    },
    // 获取预约事项列表（根据事项信息获取大厅）
    getProjectList (projectId) {
      const that = this
      that.matterLoading = true
      const params = {}
      params.page = that.pageNum
      params.size = that.pageSize
      params.hallId = that.data.hallId
      if (that.itemkeyword != undefined && that.itemkeyword != '') {
        params.itemName = that.itemkeyword
      }
      params.deptCode = this.deptCode
      // if (projectId != undefined && projectId != "") {
      //   params.deptCode = projectId;
      // }
      getItemList(params)
        .then(res => {
          that.matterLoading = false
          const { state, rows, records, total, message } = res.data
          if (state === 1) {
            if (records != undefined && records != 0) {
              if (that.pageNum == 1) {
                that.PriorProjectList = rows
              } else {
                that.PriorProjectList.push(...rows)
              }
              if (total == that.pageNum) {
                that.matteShowMore = false
              } else {
                that.matteShowMore = true
                that.pageNum++
              }
              // 是否展示无数据信息
              that.matterShowNoData = false
            } else {
              that.PriorProjectList = rows
              that.matterShowNoData = true
            }
          } else {
            Notification.error({
              title: '错误',
              message: message || '优先办事事项大厅列表获取失败'
            })
          }
        })
        .catch(err => {
          const { message } = err.data
          that.listLoading = false
          that.matterLoading = false
          Notification.error({
            title: '错误',
            message: message || '优先办事事项列表获取失败'
          })
        })
    },
    // 点击评价处理事件
    checkAppraise () {
      if (this.hallDetail.appraise) {
        return Notification.warning({
          title: '提示',
          message: '您已对此大厅进行过评价，无法再次进行评分'
        })
      }
      this.showRatePanel = true
    },
    // 提交评价信息
    submitAppraise () {
      const that = this
      if (that.submitting) {
        Notification.warning({
          title: '提示',
          message: '正在提交中，请不要重复提交'
        })
        return false
      }
      const params = {
        fraction: that.rateNum,
        hallId: that.hallDetail.hallId,
        opinion: that.rateInput,
        labelName: that.rateTag.join(',')
      }
      that.submitting = true
      submitAppraise(params)
        .then(res => {
          that.submitting = false
          const { state, message } = res.data
          if (state === 1) {
            Notification.success({ title: '成功', message: '提交成功成功' })
            that.data.appraise = true
            that.showRatePanel = false
          } else {
            Notification.warning({
              title: '失败',
              message: message || '提交失败'
            })
          }
        })
        .catch(err => {
          const { message } = err
          that.submitting = false
          Notification.error({ title: '错误', message: message || '提交出错' })
        })
    },
    formatBg1 (image) {
      // var http=image.substr(3)
      return `url(${image}) no-repeat center`
    },
    // 通过事项进来的
    getAppointmentItemInfo () {
      const itemInfo = this.itemCode
      const find = itemInfo.departList.find(d => d.label == itemInfo.depart)
      const lastCode = find ? find.value : itemInfo.depart
      getPriorProjectListByItemCode({
        itemCode: `${this.itemCode.matterInfo.ItemInfo[0].FIRST_CODE}_${lastCode}`
      })
        .then(res => {
          console.log('getPriorProjectListByItemCode')
          console.log(res)

          if (res.data && res.data.rows) {
            const find = res.data.rows.find(info => {
              const { hallInfo, projectInfo, dateInfo } = info
              return projectInfo.regionCode == this.itemCode.region
            })
            if (!find) return
            getPriorProjectInfo({
              projectId: find.projectInfo.projectId
            })
              .then(res => {
                console.log('getPriorProjectInfo')
                console.log(res)
                const { info } = res.data

                if (info && info.projectInfo) {
                  this.appointItem = info.projectInfo
                  this.showAppointment = true
                }
              })
              .catch(err => {

              })
              .finally(() => {

              })
          }
        })
        .catch(err => {

        })
        .finally(() => {

        })
    },
    // 跳转在线预约
    zxyy (item) {
      console.log('item', item)
      this.appointItem = item
      this.showAppointment = true
      const userInfo = this.$store.state.userInfo
      console.log('userInfo', userInfo)
      this.appointForm.userName = userInfo.name || ''
      this.appointForm.userPhone = userInfo.phone || ''
      this.appointForm.userCardNo = userInfo.cardNo || ''
      console.log('userInfo', this.appointForm)
    },
    // 跳转办事指南
    bszn (code) {
      if (this.isiOS) {
        window.location.href = bsznUrl + code
      } else {
        const url = bsznUrl + code
        window.open(url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.item {
  text-align: center;
  height: 40px;
  line-height: 40px;
  display: block;
  border: none;
  background: #fff;
  width: 100%;
  color: #000;
}
.title {
  font-size: 14px;
  color: #c0c0c0;
}
.title,
.baidu {
  border-bottom: solid rgba(223, 221, 221, 0.986) 1px;
}
.item-wrap .flex{
  // padding:10px 6px;
  line-height:48px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  span{
    display:inline-block;
    width:90%;
  }
  i{
    margin-right:6px;
  }
}
.header-search{
  display:flex;
  align-items:center;
  .el-input{
    width:82%;
  }
  .el-button{
    width:16%;
    padding:8px 10px;
    margin-right:10px;
  }
}
.the-hallbar {
  $hallHeaderHeight: 40px;
  $hallFooterHeight: 48px; // 48px
  $hallWidth: 320px;
  $borderRadius: 4px;
  $boxShadow: 0 2px 10px 0 rgba(142, 142, 142, 0.5);
  position: absolute;
  right: 64px;
  top: $paddingVertical;
  bottom: $paddingVertical;
  width: 0;
  .hall-image-list {
    padding: 8px $paddingHorizontal;
    white-space: nowrap;
    background-color: #fff;
    overflow-x: auto;
    ::v-deep .van-image {
      img {
        border-radius: 6px;
      }
      & + .van-image {
        margin-left: 8px;
      }
    }
  }
  &.mobile-hallbar {
    $hallFooterHeightMobile: 56px;
    position: relative;
    z-index: 5;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
    width: 100%;
    height: 100%;
    padding-top: 0;
    padding-bottom: $hallFooterHeightMobile;
    .hall-main {
      top: 0;
      width: 100%;
    }
    .hall-base-info {
      z-index: 1;
      padding-top: 0;
      padding-right: $paddingHorizontal;
    }
    .hall-rate {
      position: relative;
      top: auto;
      padding-right: 0;
      display: flex;
      align-items: flex-start;
      ::v-deep .el-rate {
        height: 20px;
        line-height: 1;
      }
      .rate-switch {
        margin-top: 0;
        margin-left: 12px;
      }
    }
    .hall-more-info {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      box-shadow: 0 1px 10px 0 #eceef2;
    }
    .hall-tab-info {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      .tab-detail {
        padding-left: 0;
        padding-right: 0;
        background-color: transparent;
      }
      ::v-deep .el-tabs.hall-tab {
        .el-tabs__active-bar {
          width: 16px !important;
          height: 4px;
          margin-left: 24px;
          background: $colorPrimary;
          border-radius: 4px;
        }
        .el-tabs__item {
          font-size: 13px;
          & + .el-tabs__item {
            padding-left: 24px;
          }
          &.is-active {
            font-size: 16px;
          }
        }
      }
    }
    .count-item {
      padding: 8px 0;
      background: linear-gradient(
        270deg,
        rgba(251, 251, 253, 0.7) 0%,
        #f5f6fa 100%
      );
      &:nth-child(even):before {
        display: none;
      }
    }
    .hall-footer {
      z-index: 2;
      display: flex;
      align-items: center;
      height: $hallFooterHeight;
      box-shadow: 0 1px 10px 0 #d2dbe7;
      border-radius: 10px 10px 0 0;
      .footer-btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: $colorTextRegular;
        i {
          margin-right: 4px;
          font-size: 22px;
          color: $colorTextSecondary;
        }
        &:hover {
          color: $colorPrimary;
          i {
            color: $colorPrimary;
            text-shadow: 3px 3px 3px rgba(147, 174, 215, 0.5);
          }
        }
      }
      .map-go {
        position: relative;
        top: -12px;
        width: 72px;
        height: 72px;
        padding: 8px;
        background-color: #fff;
        border-radius: 50%;
        // margin: 0 auto !important ;
        box-shadow: 0 -3px 3px 0 rgb(210 219 231 / 38%);
        .go-main {
          position: relative;
          width: 100%;
          height: 100%;
          color: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(
            360deg,
            #427af4 0%,
            rgba(66, 122, 244, 0.8) 100%
          );
          border-radius: 50%;
          img {
            width: 14px;
          }
        }
      }
      .ditu {
        margin: 0 auto !important;
      }
    }

    .hall-flow {
      margin-top: 4px;
      position: relative;

      & > .el-button {
        position: absolute;
        right: 0;
        top: -4px;
      }
    }
  }
  .hall-main {
    position: absolute;
    right: 0;
    top: $hallHeaderHeight;
    bottom: 0;
    width: $hallWidth;
    padding-bottom: $paddingVertical;
    background-color: $sidebarBgColor;
    border-bottom-left-radius: $borderRadius;
    border-bottom-right-radius: $borderRadius;
    box-shadow: $boxShadow;
    overflow: hidden;
  }
  &.contain-footer {
    .hall-main {
      padding-bottom: $hallFooterHeight;
    }
  }
  &.hall-collapse {
    .hall-header {
      border-bottom-left-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;
    }
  }
  .hall-tag-info {
    position: relative;
    z-index: 1;
    padding: 4px $paddingHorizontal;
    background-color: #fff;
    .tag-item {
      display: inline-block;
      height: 24px;
      margin-right: 12px;
      margin-bottom: 4px;
      line-height: 22px;
      font-size: 12px;
      font-style: normal;
      color: $colorTextRegular;
      i {
        margin-right: 4px;
        vertical-align: -1px;
        color: $colorPrimary;
      }
      // background: #F5F8FC;
      // border: 1px solid #E9E9EB;
      // border-radius: 2px;
    }
  }
  .hall-header {
    position: absolute;
    right: 0;
    top: 0;
    width: $hallWidth;
    height: $hallHeaderHeight;
    padding: 0 48px;
    line-height: $hallHeaderHeight;
    text-align: center;
    color: #fff;
    background-color: $colorPrimary;
    border-top-left-radius: $borderRadius;
    border-top-right-radius: $borderRadius;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-shadow: $boxShadow;
    .toggle-hallbar {
      position: absolute;
      left: $paddingHorizontal;
      top: 0;
      font-size: 20px;
      cursor: pointer;
    }
    .close-hallbar {
      position: absolute;
      right: $paddingHorizontal;
      top: 0;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .hall-footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: $hallFooterHeight;
    padding: 8px;
    .btn-column {
      float: left;
      width: 50%;
      padding: 0 8px;
      ::v-deep .el-button {
        width: 100%;
      }
    }
  }
  .hall-body {
    position: relative;
    height: 100%;
  }
  .hall-intro {
    background-color: #f1f4f6;
  }
  .hall-image {
    position: relative;
    height: 120px;
    background-size: cover !important;
    cursor: pointer;
    .image-tip {
      position: absolute;
      left: $paddingHorizontal;
      bottom: 8px;
      padding: 0 4px;
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.4;
        border-radius: 2px;
      }
      span {
        position: relative;
        font-size: 12px;
        color: #fff;
        i {
          margin-right: 4px;
          font-size: 14px;
          vertical-align: -2px;
        }
      }
    }
  }
  .hall-base-info {
    position: relative;
    padding: 8px 100px 8px $paddingHorizontal;
    background-color: #fff;
    min-height: 90px;
    transition: .2s ease-in-out;
    &.height {
      height: 120px;
    }
  }
  .hall-name {
    font-size: 16px;
    font-weight: 500;
    color: $colorTextPrimary;
  }
  .hall-type {
    margin-top: 4px;
    font-size: 12px;
    color: $colorTextSecondary;
    span {
      display: inline-block;
      & + span {
        &:before {
          content: "|";
          vertical-align: 1px;
          margin: 0 4px;
        }
      }
    }
  }
  .hall-flow {
    margin-top: 4px;
    position: relative;

    & > .el-button {
      position: absolute;
      right: -84px;
      top: -4px;
    }
  }
  .hall-rate {
    position: absolute;
    right: 0;
    top: 8px;
    padding-right: $paddingHorizontal;
    ::v-deep .el-rate {
      height: 24px;
      line-height: 24px;
      .el-rate__icon {
        margin-right: 0;
        font-size: 12px;
        vertical-align: middle;
      }
      .el-rate__text {
        margin-left: 8px;
      }
    }
    .rate-switch {
      margin-top: 4px;
      font-size: 12px;
      color: $colorPrimary;
      text-align: right;
      cursor: pointer;
      i {
        vertical-align: -2px;
      }
    }
  }
  .hall-more-info {
    position: relative;
    padding: 12px $paddingHorizontal;
    font-size: 12px;
    background-color: #fff;
    &:before {
      content: "";
      position: absolute;
      left: $paddingHorizontal;
      right: $paddingHorizontal;
      top: 0;
      border-top: 1px dashed $borderColorPrimary;
    }
    .info-item {
      a {
        color: $colorTextRegular;
        &:hover {
          color: $colorPrimary;
        }
      }
      & + .info-item {
        margin-top: 4px;
      }
      i {
        margin-right: 4px;
        vertical-align: -2px;
        color: $colorTextSecondary;
      }
    }
  }
  ::v-deep .el-scrollbar__thumb {
    opacity: 0;
  }

  ::v-deep .list-wrap {
    .el-collapse-item__header {
      height: auto;

      .flex {
        display: flex;
        align-items: baseline;

        i {
          margin-right: 5px;
        }
      }
    }

    .el-collapse-item__content {
      padding-bottom: 10px;
      .btn-wrap {
        text-align: right;
      }
    }
  }
  .hall-tab-info {
    margin-top: 8px;
    background-color: #fff;
    .tab-detail {
      padding: $paddingVertical $paddingHorizontal;
      background-color: #f5f7fa;
      .tab-detail-title {
        margin-bottom: 4px;
        font-weight: 600;
        color: $colorTextPrimary;
      }
      .tab-detail-content {
        ~ .tab-detail-title {
          margin-top: 16px;
        }
        &.count-content {
          overflow: hidden;
        }
        a {
          color: $colorTextRegular;
          &:hover {
            color: $colorPrimary;
          }
        }
        i {
          margin-right: 4px;
          color: $colorTextSecondary;
          vertical-align: -2px;
        }
        &.dynamic-content {
          i {
            margin-right: 12px;
            font-size: 16px;
            color: $colorPrimary;
          }
          em {
            margin-left: 24px;
            font-size: 18px;
            font-weight: 600;
            color: $colorTextPrimary;
          }
          .dynamic-item {
            position: relative;
            & + .dynamic-item {
              padding-top: 8px;
              margin-top: 8px;
              &:before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                height: 1px;
                background-color: #eee;
              }
            }
          }
        }
      }
    }
    ::v-deep .el-tabs {
      &.mode-tab {
        & > .el-tabs__header {
          margin-bottom: 0;
          .el-tabs__nav {
            border-left: none;
            border-right: none;
          }
          .el-tabs__item {
            color: $colorTextSecondary;
            background: #f0f3f6;
            background: linear-gradient(180deg, #ffffff 0%, #f0f3f6 100%);
            border-left: none;
            border-right: none;
            &:hover {
              color: $colorPrimary;
            }
            &.is-active {
              color: $colorPrimary;
              background: #fff;
            }
          }
        }
        & > .el-tabs__content {
          & > .el-tab-pane {
            padding: 0 $paddingHorizontal;
          }
        }
      }
      &.hall-tab {
        .el-tabs__header {
          padding: 0 4px;
          margin-bottom: 0;
        }
        .el-tabs__item {
          padding: 0;
          font-size: 14px;
          font-weight: 400;
          &:focus.is-active.is-active:not(:active) {
            box-shadow: none;
          }
        }
        .el-tabs__nav-wrap::after {
          display: none;
        }
        .el-tabs__active-bar {
          width: 32px !important;
          margin-left: 23px;
        }
        &.item-tab {
          .el-tabs__active-bar {
            margin-left: 62px;
          }
        }
      }
    }
    &.hide-mode-tab {
      ::v-deep .el-tabs {
        &.mode-tab {
          & > .el-tabs__header {
            display: none;
          }
        }
      }
    }
  }
  .count-item {
    position: relative;
    float: left;
    width: 50%;
    text-align: center;
    .item-num {
      color: $colorPrimary;
      em {
        font-style: normal;
        font-size: 20px;
        font-weight: 600;
      }
    }
    &:nth-child(even) {
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 1px;
        height: 24px;
        margin: auto 0;
        background-color: #cccbcb;
      }
    }
  }
  .window-item {
    min-height: 80px;
    padding: $paddingVertical $paddingHorizontal;
    background: url("~@img/windowbg.png") #f8f9fc no-repeat center right;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    overflow: hidden;
    label {
      display: block;
      margin-bottom: 4px;
      font-size: 12px;
    }
    span {
      display: block;
      font-weight: 500;
      color: $colorTextPrimary;
    }
    & > div {
      float: left;
      width: 30%;
      padding-right: 8px;
      &.item-name {
        width: 40%;
      }
    }
    & + .window-item {
      margin-top: 8px;
    }
  }
  .item-title {
    padding-top: 8px;
    margin-bottom: 8px;
    font-weight: 500;
    color: $colorTextPrimary;
  }
}
.rate-panel {
  &.mobile-rate-panel {
    ::v-deep .el-dialog__header {
      padding-bottom: 48px;
      background: url("~@img/ratepanelbg.png") no-repeat center top;
      background-size: cover;
      border-bottom: none;
    }
    .rate-main {
      margin-top: -40px;
      padding: $paddingVertical $paddingHorizontal 72px;
      background: #fff;
      box-shadow: 0 1px 10px 0 rgba(210, 219, 231, 0.6);
      border-radius: 6px;
    }
    .rate-hall-name {
      font-size: 20px;
    }
    .rate-content {
      padding-left: 0;
    }
    ::v-deep .el-dialog__footer {
      margin-top: -72px;
    }
  }
  ::v-deep .el-dialog {
    max-width: 100%;
  }
  ::v-deep .el-dialog__header {
    padding-bottom: $paddingVertical;
    border-bottom: 1px solid $borderColorPrimary;
  }
  ::v-deep .el-dialog__body {
    padding-top: $paddingVertical;
  }
  .rate-title {
    margin-bottom: 24px;
    font-size: 16px;
    text-align: center;
  }
  .rate-hall-name {
    font-size: 16px;
    font-weight: 500;
    color: $colorTextPrimary;
  }
  .rate-hall-type {
    margin-top: 4px;
    font-size: 12px;
    color: $colorTextSecondary;
    span {
      display: inline-block;
      & + span {
        &:before {
          content: "|";
          vertical-align: 1px;
          margin: 0 4px;
        }
      }
    }
  }
  .rate-input {
    ::v-deep .el-textarea__inner {
      background: #f9f9f9;
      border-radius: 2px;
      border: 1px solid #e4e6eb;
    }
  }
  .rate-label {
    margin-bottom: 8px;
    color: $colorTextPrimary;
    i {
      margin-right: 4px;
      font-size: 16px;
      color: $colorPrimary;
      vertical-align: -3px;
    }
  }
  .rate-item {
    margin-bottom: 24px;
  }
  .rate-content {
    padding-left: 20px;
    ::v-deep .el-checkbox {
      min-width: 130px;
      max-width: 200px;
      padding: 4px 8px;
      margin-right: 16px;
      margin-bottom: 8px;
      text-align: center;
      vertical-align: top;
      color: $colorTextRegular;
      background: #f5f6fa;
      background: linear-gradient(
        270deg,
        rgba(251, 251, 253, 0.7) 0%,
        #f5f6fa 100%
      );
      border: 1px solid transparent;
      transition: $transitionTime;
      &:hover {
        color: $colorPrimary;
      }
      &.is-checked {
        border-color: $colorPrimary;
      }
      .el-checkbox__input {
        display: none;
      }
      .el-checkbox__label {
        padding: 0;
        font-weight: normal;
        white-space: normal;
      }
    }
  }
}

::v-deep .el-drawer__wrapper {
  z-index: 9999;
  height: 100%;
}
::v-deep .el-drawer__header {
  background: transparent;
  margin-bottom: 0;
  padding-bottom: 20px;
}

::v-deep .el-drawer.rtl {
  padding-bottom: 30px;
  background: url("~@img/ratepanelbg-red.png") no-repeat center top;
  background-size: 100% auto;
  border-bottom: none;
  background-color: #fff;
}
.mobile-drawer-panel {
  ::v-deep .el-drawer {
    width: 100% !important;
  }
}
.appoint-header {
  color: #000;
}
.appoint-drawer-wrap {
  width: calc(100% - 10vw);
  margin: auto;

  .item-info {
    .label {
      font-size: 20px;
    }

    .sub-label {
      color: #919398;
    }
  }

  .step-wrap {
    padding: 16px 16px;
    background: #fff;
    box-shadow: 0 1px 10px 0 rgb(210 219 231 / 60%);
    border-radius: 6px;
    margin-top: 20px;
    padding-bottom: 1px;

    .label {
      margin-bottom: 8px;
      color: #1f2026;
      i {
        margin-right: 4px;
        font-size: 16px;
        color: #d4000b;
        vertical-align: -3px;
      }
    }
  }

  .btn-wrap {
    margin-top: 20px;
    text-align: center;
  }
}

.order-period {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .period {
    width: 30%;
    text-align: center;
    border: 1px solid #e4e4e4;
    border-radius: 5px;
    margin-bottom: 14px;
    line-height: 26px;

    &.active {
      background: #f33942;
      color: #fff;
    }
  }
}
</style>
